import fetch from 'isomorphic-fetch'
import { connect } from 'react-redux'

import * as Jsx from './index.jsx'
const RxComponent = global.rootRequire('components/shares/rxComponent').default

const { rxsetLocal, rxgetLocal } = global.rootRequire('classes/request')
const { setComp, rxnavToggle, rxnavClose, netaloginAction } = global.rootRequire('redux')
const dHeaders = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8' }

const crypto = require('crypto')

class Component_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.keyClickFunction = this.keyClickFunction.bind(this);
    this.token = ''
    this.tokenLogin = ''
    this.state = global.rootContext(this.props.staticContext) || {
      flagStep: 0,
      inputUsername: '',
      inputPass: '',
      errMess: '',
      errMessDesc: '',
      flagShowPass: false,
      checkSaveLogin: true
    }
  }

  componentDidMount() {
    rxsetLocal('rxusers', JSON.stringify({ status: false, users: {}, ids: [] }))
    rxsetLocal('netaLastSeenMessObj', JSON.stringify({}))

    document.addEventListener("keydown", this.keyClickFunction, false);
    this.fetchSession()
    this.checkAuth()
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyClickFunction, false);
  }

  checkAuth() {
    if (global.rxu.get(this.props, 'netaauth.user.id')) {
      this.props.setComp('chat')
    }
  }

  keyClickFunction(event) {
    if (event.keyCode === 13) {
      this.onClickLogin()
    }
  }

  onClickDisplayPass() {
    let flagShowPass = this.state.flagShowPass
    this.setState({
      flagShowPass: !flagShowPass
    })
  }

  changeCheckedSaveMe() {
    let checkSaveLogin = this.state.checkSaveLogin
    this.setState({
      checkSaveLogin: !checkSaveLogin
    })
  }

  onClickLogin() {
    let username = this.state.inputUsername
    let password = this.state.inputPass

    if (!username) {
      this.setState({ errMess: 'UserName không được để trống' })
      setTimeout(() => { this.setState({ errMess: '' }) }, 3000)
    } else if (!password) {
      this.setState({ errMess: 'Password không được để trống' })
      setTimeout(() => { this.setState({ errMess: '' }) }, 3000)
    } else {
      if (this.token) {
        let params = { username: username, password: password }

        let headers = { 'TC-Token': this.token, ...dHeaders }
        fetch(global.rxu.config.base_api_neta + '/api/login.json', {
          method: 'POST',
          body: JSON.stringify(params),
          headers: headers
        })
          .then((res) => { return res.json() })
          .then((json) => {
            if (json) {
              if (json.banned) {
                this.setState({
                  errMess: 'Tài khoản đã bị vô hiệu hóa',
                  errMessDesc: 'Tài khoản này đã bị vô hiệu hóa bởi quản trị viên hệ thống. Vui lòng liên hệ email support@bobacu.vn để biết thêm chi tiết',
                })
                setTimeout(() => { this.setState({ errMess: '', errMessDesc: '' }) }, 10000)
              } else {
                if (json.token) {
                  this.helpGetUserinfoAndLogin(json.token, (jsonb) => {
                    this.props.netaloginAction({ token: json.token, name: jsonb.full_name, id: jsonb.Id, phone: jsonb.phone })
                    if (window && window.location && window.location.href && window.location.href.indexOf('join_meet') !== -1) {
                      this.props.setComp('join_meet')
                    } else {
                      this.props.setComp('chat')
                    }
                  }, () => {
                    this.setState({
                      inputUsername: '',
                      inputPass: '',
                      errMess: '',
                      flagShowPass: false,
                      checkSaveLogin: false
                    })
                  })
                } else {
                  if (json.Code === 1030) {
                    this.setState({ errMess: 'Username hoặc Password chưa đúng, vui lòng thử lại' })
                  } else if (json.Code === 1012) {
                    this.setState({ errMess: 'Username hoặc Password chưa đúng, vui lòng thử lại' })
                  } else if (json.Code === 1018) {
                    this.setState({ errMess: 'Đăng nhập sai quá nhiều lần. Vui lòng thử lại sau' })
                  } else {
                    this.setState({ errMess: 'Username hoặc Password chưa đúng, vui lòng thử lại' })
                  }
                  setTimeout(() => { this.setState({ errMess: '' }) }, 3000)
                }
              }
            } else {
              this.setState({ errMess: 'Lỗi kết nối ' })
              setTimeout(() => { this.setState({ errMess: '' }) }, 3000)
            }
          })
          .catch(er => console.log(er))
      } else {
        this.setState({ errMess: 'Lỗi kết nối ' })
        setTimeout(() => { this.setState({ errMess: '' }) }, 3000)
      }
    }
  }

  openExternalLink(url) {
    if (window && window.ipcRenderer && url) {
      window.ipcRenderer.send('open-external-link', { link: url })
    } else if (window && url) {
      window.open(url, '_blank')
    }
  }


  helpGetUserinfoAndLogin(token, callback, callbackFailed) {
    fetch(global.rxu.config.base_api_neta + '/api/session.json', {
      method: 'GET',
      headers: { 'TC-Token': token, ...dHeaders }
    }).then(r => r.json()).then((json) => {
      if (json.user_id) {
        fetch(global.rxu.config.base_api_neta + '/api/users/' + json.user_id, {
          method: 'GET',
          headers: { 'TC-Token': token, ...dHeaders }
        }).then(r => r.json()).then((jsonb) => {
          if (jsonb && jsonb.Id) {
            callback(jsonb)
          }
        })
      }
    })
  }

  updateInput(inputName, e) {
    let state = {}
    state[inputName] = e.target.value
    this.setState(state)
  }

  genSignature() {
    let appID = global.rxu.config.application_id
    let appKey = global.rxu.config.auth_key
    let timestamp = Math.floor(Date.now() / 1000)
    let nonce = Math.floor(Math.random() * 89999) + 10000
    let content = "application_id=" + appID + "&auth_key=" + appKey + "&nonce=" + nonce + "&timestamp=" + timestamp
    let signalstr = crypto.createHmac('sha1', appKey).update(content).digest('hex')

    let result = {
      'application_id': appID,
      'auth_key': appKey,
      'nonce': nonce,
      'signature': signalstr,
      'timestamp': timestamp
    }


    return result
  }

  fetchSession() {
    let params = this.genSignature()
    fetch(global.rxu.config.base_api_neta + '/api/session.json', {
      method: 'POST',
      body: JSON.stringify(params),
      headers: dHeaders
    }).then((res) => { return res.json() })
      .then((json) => {
        if (!json.Code || json.Code === 200) {
          this.token = json.token
        }
      }).catch(er => console.log(er))
  }

  render() {
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  auth: state.auth,
  register: state.register,
  favorite: state.favorite,
  netaauth: state.netaauth
})

const mapDispatchToProps = {
  rxnavClose,
  rxnavToggle,
  netaloginAction,
  setComp
}

const ComponentWrapped = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component_)

export default ComponentWrapped
